<template>
  <div style="position:relative">
    <div class="butt">
      <a-button @click="submit" type="primary" v-if="$auth('assetClassManagement.save')" >保存</a-button>
      <a-button @click="reset" style="margin:0 10px">重置</a-button>
    </div>
    <a-spin :spinning="loading">
      <a-tree
        ref="tree"
        :treeData="treeData"
        checkable
        :checkStrictly="true"
        :autoExpandParent="autoExpandParent"
        @check="onCheck"
        @expand="onExpand"
        v-model="checkedKeys"
        :expandedKeys="expandedKeys"
      >
        <template slot="custom" slot-scope="role">
          <a-tooltip placement="topLeft" :title="role.name">
            <span class="title-name">{{ role.name }}</span>
          </a-tooltip>
        </template>
      </a-tree>
    </a-spin>

  </div>
</template>

<script>
import { getCompanyTree } from '@/api/organizationalStructure'
import { getSapData, setSapData } from '@/api/relevant.js'
import { getAssisClass, getAssisClassByType, saveAssisClassByType } from '@/api/assetClassManagement'
import { mapGetters } from 'vuex'
export default {
  async mounted () {
    await this.initTree()
  },
  data () {
    return {
      treeData: [],
      checkedKeys: [],
      expandedKeys: [],
      loading: false,
      autoExpandParent: true
    }
  },
  computed: {
    ...mapGetters(['assetTreeId'])
  },
  watch: {
    assetTreeId (newValue) {
      this.typeCode = newValue.code
      this.getSelectData()
    }
  },
  methods: {
    // 树结构
    async initTree () {
      this.loading = true
      const res = await getAssisClass()
      if (res && res.status === 0) {
        const loop = data => {
          for (let i = 0; i < data.length; i++) {
            data[i].key = data[i].code
            data[i].scopedSlots = {
              title: 'custom'
            }
            if (data[i].children) {
              loop(data[i].children)
            }
          }
        }
        loop(res.data)
        this.treeData = res.data
      }
      this.loading = false
    },
    // 对应spa部门权限数据
    async getSelectData () {
      this.loading = true
      const params = { typeCode: this.typeCode }
      const res = await getAssisClassByType(params)
      if (res && res.status === 0) {
        this.checkedKeys = res.data.map(item => {
          return item.code
        })
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    // 保存
    async submit () {
      if (this.checkedKeys.length === 0) {
        this.$message.warning('请至少选中一个资产')
        return
      }
      this.loading = true
      const params = this.checkedKeys.map(item => {
        return {
          code: item,
          typeCode: this.typeCode
        }
      })
      const res = await saveAssisClassByType(params)
      if (res && res.status === 0) {
        this.getSelectData()
        this.$message.success(res.info.message)
      } else {
        this.$message.error(res.info.message)
      }
      this.loading = false
    },
    reset () {
      this.getSelectData()
    },
    // 由选中数组得展开数组
    getExpandedKeys () {
      let arr = []
      const stack = []
      const loop = data => {
        for (let i = 0; i < data.length; i++) {
          // do
          if (this.checkedKeys.indexOf(data[i].key) !== -1) {
            arr = [...arr, ...stack]
          }
          stack.push(data[i].key)
          if (data[i].children) {
            loop(data[i].children)
          }
          stack.pop()
        }
      }
      loop(this.treeData)
      return Array.from(new Set(arr))
    },
    onCheck (checkedKeys, e) {
      this.checkedKeys = checkedKeys.checked
    },
    onExpand (expandedKeys, option) {
      // this.expandedKeys = expandedKeys
      // this.autoExpandParent = false
    }
  }
}
</script>

<style scoped lang="less">
/deep/ .ant-tree.ant-tree-icon-hide {
  overflow-y: visible !important;
}
.butt {
  display:flex;
  position: absolute;
  top: 0;
  right: 0;
  z-index: 100;
}
</style>
